import { Button } from '@/components';

type Props = {
  message?: string;
  btnA: {
    text: string;
    action: () => void;
  };
  btnB: {
    text: string;
    action: () => void;
  };
};

// Possible Registration errors
export const REG_ERRORS = {
  100: {
    btnA: {
      text: 'Modificar Documento',
    },
    btnB: {
      text: 'Cerrar Sesión',
    },
  },
  150: {
    btnA: {
      text: 'Olvidé mi e-mail',
    },
    btnB: {
      text: 'Cerrar',
    },
  },
};

const RegistrationErrorActions = ({ message, btnA, btnB }: Props) => {
  return (
    <div className="flex flex-col items-center space-y-8">
      {message && <p className="text-sm text-center">{message}</p>}
      <div className="flex justify-between w-full mt- lg:flex-row space-x-1">
        <Button
          className="lg:max-w-xs px-0 flex-1 max-w-full"
          id="btnAccept"
          type="button"
          variant="secondary"
          onClick={() => {
            btnA.action();
          }}
        >
          {btnA.text}
        </Button>
        <Button
          className="lg:max-w-xs px-0 flex-1 max-w-full"
          id="btnAccept"
          type="button"
          variant="primary"
          onClick={() => {
            btnB.action();
          }}
        >
          {btnB.text}
        </Button>
      </div>
    </div>
  );
};

export default RegistrationErrorActions;
